var _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZoomIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_602_1888)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 50,
    height: 50,
    rx: 5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5586 18.6434H25.7379C25.9553 18.6434 26.1315 18.8609 26.1315 19.037V29.2599C26.1315 29.4774 25.9553 29.6535 25.7379 29.6535H24.5586C24.3412 29.6535 24.165 29.4361 24.165 29.2599V19.037C24.165 18.8196 24.3412 18.6434 24.5586 18.6434Z",
    fill: "#0D6666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0381 23.1649H30.2611C30.4785 23.1649 30.6547 23.3823 30.6547 23.5585V24.7378C30.6547 24.9552 30.4785 25.1313 30.2611 25.1313H20.0381C19.8207 25.1313 19.6445 24.9139 19.6445 24.7378V23.5585C19.6445 23.3411 19.8207 23.1649 20.0381 23.1649Z",
    fill: "#0D6666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1334 13.0579C23.0991 12.7455 20.0718 13.7074 17.7725 15.7123C15.4745 17.7186 14.1106 20.5863 14.0063 23.6356C13.9031 26.6836 15.0686 29.6394 17.2249 31.7956C19.3826 33.9519 22.3372 35.1175 25.3865 35.0142C28.4344 34.9097 31.3036 33.546 33.3084 31.2467C35.3134 28.9487 36.2752 25.9214 35.9629 22.8873C35.7042 20.3677 34.5854 18.0161 32.7952 16.2258C31.0049 14.4356 28.6515 13.3166 26.1334 13.0579ZM25.0105 32.8168C22.6753 32.8168 20.4352 31.8893 18.7837 30.2367C17.131 28.5854 16.2036 26.3451 16.2036 24.0099C16.2036 21.6747 17.131 19.4346 18.7837 17.7832C20.435 16.1305 22.6753 15.2031 25.0105 15.2031C27.3457 15.2031 29.5859 16.1305 31.2373 17.7832C32.89 19.4344 33.8175 21.6747 33.8175 24.0099C33.8175 26.3451 32.89 28.5852 31.2373 30.2367C29.586 31.8893 27.3457 32.8168 25.0105 32.8168Z",
    fill: "#0D6666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.436 39.7107L34.2342 30.509C33.97 30.8833 33.6824 31.2425 33.3755 31.5837C32.8155 32.2002 32.1894 32.7534 31.5068 33.2309L40.7114 42.4354C41.4641 43.1881 42.6834 43.1881 43.4361 42.4354C44.1888 41.6827 44.1887 40.4634 43.436 39.7107Z",
    fill: "#0D6666"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_602_1888",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_602_1888"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_602_1888",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIcon);
export default __webpack_public_path__ + "static/media/zoom_icon.03e83048603b6ddf58f6e871739a386f.svg";
export { ForwardRef as ReactComponent };